import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { movieBookingApi } from '../../services/movieBookingApi';
import { getMovieBookingRole, isAdminRole } from './movieBookingRole';
import './MovieBooking.css';

const AdminMovieForm = () => {
  const { user } = useAuth();
  const isAdmin = isAdminRole(user) || getMovieBookingRole() === 'ADMIN';
  const [title, setTitle] = useState('');
  const [language, setLanguage] = useState('');
  const [genre, setGenre] = useState('');
  const [durationMinutes, setDurationMinutes] = useState(120);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  if (!isAdmin) {
    return (
      <div className="movie-booking-page">
        <h1 className="movie-booking-title">Admin access required</h1>
        <p className="movie-booking-note">Switch to Admin role to manage movies.</p>
      </div>
    );
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage('');
    try {
      const payload = {
        title,
        language,
        genre,
        durationMinutes: Number(durationMinutes),
      };
      const response = await movieBookingApi.createMovie(payload);
      setMessage(`Movie created: ${response.data?.title || response.data?.id}`);
      setTitle('');
      setLanguage('');
      setGenre('');
      setDurationMinutes(120);
    } catch (error) {
      setMessage('Failed to create movie.');
    }
  };

  return (
    <div className="movie-booking-page">
      <div className="movie-booking-header">
        <h1 className="movie-booking-title">Create Movie</h1>
        <button className="movie-booking-button secondary" onClick={() => navigate('/movies/admin')}>
          Back
        </button>
      </div>

      <form className="movie-booking-form" onSubmit={handleSubmit}>
        <input
          className="movie-booking-input"
          placeholder="Movie Title"
          value={title}
          onChange={(event) => setTitle(event.target.value)}
          required
        />
        <input
          className="movie-booking-input"
          placeholder="Language"
          value={language}
          onChange={(event) => setLanguage(event.target.value)}
          required
        />
        <input
          className="movie-booking-input"
          placeholder="Genre"
          value={genre}
          onChange={(event) => setGenre(event.target.value)}
          required
        />
        <input
          className="movie-booking-input"
          type="number"
          min="1"
          placeholder="Duration (minutes)"
          value={durationMinutes}
          onChange={(event) => setDurationMinutes(event.target.value)}
          required
        />
        <button className="movie-booking-button" type="submit">Create Movie</button>
      </form>
      {message && <p className="movie-booking-note">{message}</p>}
    </div>
  );
};

export default AdminMovieForm;
